//import global API
import Api from "../../api/axios";

const auth = {

    //set namespace true
    namespaced: true,

    //state
    state: {

        //state untuk "token", pakai localStorage, untuk menyimpan informasi tentang token
        token: localStorage.getItem('token') || '',

        //state "user", pakai localStorage, untuk menyimpan data user yang sedang login
        user: JSON.parse(localStorage.getItem('user')) || {},

    },

    //mutations
    mutations: {

        //update state "token" dan state "user" dari hasil response
        AUTH_SUCCESS(state, token, user) {
            state.token   = token // <-- assign state "token" dengan response "token"
            state.user    = user // <-- assign state "user" dengan response data "user"
        },

        //update state user dari hasil response register / login
        GET_USER(state, user) {
            state.user = user // <-- assign state user dengan response data user
        },

        //fungsi logout
        AUTH_LOGOUT(state) {
            state.token = '' // <-- set state token ke empty
            state.user  = {} // <-- set state user ke empty array
        },


        CHANGE_PASSWORD(state, new_password, current_password) {

            state.new_password = new_password
            state.current_password = current_password
        },

    },

    //actions
    actions: {

        //action login
        login({ commit }, user) {

            //define callback promise
            return new Promise((resolve, reject) => {

                Api.post('/login', {

                    //data yang dikirim ke server
                    telp_1: user.telp_1,
                    password: user.password,

                  })

                  .then(response => {

                    //define variable dengan isi hasil response dari server
                    const token = response.data.data.access_token
                    const user  = response.data.data

                    //set localStorage untuk menyimpan token dan data user
                    localStorage.setItem('token', token)
                    localStorage.setItem('user', JSON.stringify(user))

                    //set default header axios dengan token
                    Api.defaults.headers.common['Authorization'] = `Bearer ${token}`

                    //commit auth success ke mutation
                    commit('AUTH_SUCCESS', token, user)

                    //commit get user ke mutation
                    commit('GET_USER', user)

                    //resolve ke component dengan hasil response
                    resolve(response)

                  }).catch(error => {

                      //jika gagal, remove localStorage dengan key token
                      localStorage.removeItem('token')
                        console.log (error.response);
                      //reject ke component dengan hasil response
                      reject(error.response)

                  })

            })
        },

        //action registerAccount
        storeAccountRegistration({ commit },data) {

            return new Promise((resolve, reject) => {

                const token = localStorage.getItem('token')
                Api.defaults.headers.common['Authorization'] = `Bearer ${token}`


                Api.post('register', {
                    nama: data.nama,
                    NIK: data.nik,
                    jenis_kelamin: data.jenis_kelamin,
                    tgl_lahir: data.tgl_lahir,
                    telp_1: data.telp_1,
                    email: data.email,
                    password: data.password,
                    c_password: data.c_password,

                })
                    .then(response => {

                        commit
                        console.log('Success register')
                        resolve(response)

                    }).catch(error => {

                       
                        reject(error.response)
                        console.log(error)

                    })
            })
        },

        //action getUser
        getUser({ commit }) {

            //ambil data token dari localStorage
            const token = localStorage.getItem('token')

            Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
            Api.get('/user/profile')
            .then(response => {
                //console.log(response.data.data)
                //commit ke mutatuin GET_USER dengan hasil response
                commit('GET_USER', response.data.data)

            })
        },

        //action logout
        logout({ commit }) {

            //define callback promise
            return new Promise((resolve) => {

                //commit ke mutation AUTH_LOGOUT
                commit('AUTH_LOGOUT')

                //remove value dari localStorage
                localStorage.removeItem('token')
                localStorage.removeItem('user')

                //di atas kita set data-nya menjadi 0

                //delete header axios
                delete Api.defaults.headers.common['Authorization']

                //return resolve ke component
                resolve()

            })
        },
        //action chage  password
        changepassword({ commit }, user) {

            //define callback promise
            return new Promise((resolve, reject) => {

                const token = localStorage.getItem('token')
                Api.defaults.headers.common['Authorization'] = `Bearer ${token}`

                Api.post('/user/change_password', {

                    //data yang dikirim ke server
                    current_password: user.current_password,
                    new_password: user.new_password,

                  })

                  .then(response => {

                    const new_password  = response.data.data
                    const current_password  = response.data.data

                     //remove value dari localStorage
                    //localStorage.removeItem('token')
                    //localStorage.removeItem('user')

                    //commit auth success ke mutation
                    commit('CHANGE_PASSWORD',new_password, current_password)

                    resolve(response)

                  }).catch(error => {

                      //jika gagal, remove localStorage dengan key token
                     // localStorage.removeItem('token')
                        console.log (error.response);
                      //reject ke component dengan hasil response
                      reject(error.response)

                  })

            })
        },

    },

    //getters
    getters: {

        //get current user
        currentUser(state) {
            return state.user // <-- return dengan data user
        },

        //loggedIn
        isLoggedIn(state) {
            return state.token // return dengan data token
        },

    }

}

export default auth
